'use client'

import { cn } from '@brew/ui/cn'
import { homeButtonClasses } from '@/components/marketing/home/home-button'
import { MK_SMALL } from '@/components/marketing/home/home-layout'
import { useEmailAuditCopy } from './use-email-audit-copy'
import type { EmailAuditHandoff } from './use-email-audit-handoff'

/**
 * Shown when the browser refused to keep the email for Brew (a private
 * window, blocked or full storage): the email stays here to download, and
 * sign-in opens only when the visitor chooses to go on without it.
 */
export function EmailAuditHandoffBlocked({
  handoff,
  isCentered = false,
}: {
  handoff: Pick<EmailAuditHandoff, 'downloadEmail' | 'continueWithoutEmail'>
  /** Under a centered section header. */
  isCentered?: boolean
}) {
  const { rendering } = useEmailAuditCopy()
  return (
    <div
      role="alert"
      className={cn(
        'flex w-full max-w-md flex-col gap-2 rounded-xl bg-mk-tile p-3 ring-1 ring-mk-line',
        { 'items-center text-center': isCentered }
      )}
    >
      <p className={cn(MK_SMALL, 'text-mk-body')}>{rendering.blockedBody}</p>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={handoff.downloadEmail}
          className={homeButtonClasses({ variant: 'outline', size: 'sm' })}
        >
          {rendering.blockedDownload}
        </button>
        <button
          type="button"
          onClick={handoff.continueWithoutEmail}
          className={homeButtonClasses({ variant: 'light', size: 'sm' })}
        >
          {rendering.blockedContinue}
        </button>
      </div>
    </div>
  )
}
